export default __webpack_public_path__ + "static/media/module-spinner.e4070560.svg";